import { OrgChartCanvas } from '@tatatemplate/shared-lib/org-chart-canvas'
import { useOrgChart } from '../hooks/use-org-chart'
import { ChartNodeCard } from './ChartNodeCard'

interface OrganizationalChartProps {
  /** Kept for backward-compat with call sites; data is now fetched internally. */
  struktur?: unknown
  showHeader?: boolean
}

export function OrganizationalChart({ showHeader = true }: OrganizationalChartProps) {
  const { data, isLoading, isError } = useOrgChart()

  if (isLoading) {
    return <div className="h-[600px] rounded-lg bg-slate-100 animate-pulse" />
  }

  return (
    <div>
      {showHeader && (
        <h2 className="text-xl font-bold text-slate-800 mb-4">Struktur Organisasi Pemerintahan Desa</h2>
      )}
      <OrgChartCanvas
        data={data ?? { struktur: null, nodes: [], edges: [] }}
        emptyText={isError ? 'Gagal memuat bagan organisasi. Silakan muat ulang halaman.' : undefined}
        renderNode={(args) => <ChartNodeCard {...args} />}
      />
    </div>
  )
}
